document.addEventListener('DOMContentLoaded', function() {
  initDiscountOverlayCopy();
});

function initDiscountOverlayCopy() {
  const copyButtons = document.querySelectorAll('.discount-overlay-copy-btn');
  const closeButtons = document.querySelectorAll('.js-close-overlay');

  copyButtons.forEach(button => {
    button.addEventListener('click', function() {
      const codeElement = this.closest('.discount-overlay-code').querySelector('p');
      if (codeElement) {
        const code = codeElement.textContent.trim();
        copyDiscountCode(code, this);
      }
    });
  });

  closeButtons.forEach(button => {
    button.addEventListener('click', function() {
      const overlay = this.closest('.discount-overlay');
      if (overlay) {
        overlay.classList.add('hidden');
      }
    });
  });
}

function copyDiscountCode(code, buttonElement) {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(code).then(function() {
      showCopyFeedback(buttonElement);
    }).catch(function(err) {
      console.error('Failed to copy: ', err);
    });
  } else {
    const textArea = document.createElement("textarea");
    textArea.value = code;
    textArea.className = 'visually-hidden-copy-helper';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      showCopyFeedback(buttonElement);
    } catch (err) {
      console.error('Fallback: Failed to copy', err);
    }
    document.body.removeChild(textArea);
  }
}

function showCopyFeedback(buttonElement) {
  const container = buttonElement.closest('.discount-overlay-code-container');
  const toast = container ? container.querySelector('.discount-overlay-toast') : null;
  
  if (toast) {
    toast.classList.add('show');
    setTimeout(function() {
      toast.classList.remove('show');
    }, 3000);
  }
}
